import "./changepass.css";
import { useSearchParams } from "react-router-dom";
import { FaPhoneSquareAlt, FaPhoneAlt } from "react-icons/fa";
import { useEffect, useState } from "react";

function Changephone() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const [newPhone, setNewPhone] = useState("");
  const [error, setError] = useState(null);
  const [vendordata, setVendorData] = useState(null);
  const [success, setSuccess] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    if (!token) {
      alert("Missing or invalid token.");
      return;
    }

    if (!newPhone) {
      alert("Please fill the phone number.");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("token", token);
      formData.append("type", "phone");
      formData.append("new_phone", newPhone);

      const res = await fetch(
        `${process.env.REACT_APP_BASEURL}/apis/vendor/update_credential.php`,
        {
          method: "POST",
          body: formData,
        }
      );

      const data = await res.json();
      if (data.success) {
        setSuccess(true);
      } else {
        alert(data.message || "Failed to update phone number.");
      }
    } catch (err) {
      console.error("Error:", err);
      alert("Something went wrong.");
    } finally {
      setIsSubmitting(false); // 🔹 Blur ends
    }
  };

  useEffect(() => {
    if (!token) {
      setError("Missing token.");
      return;
    }

    const checkToken = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_BASEURL}/apis/verify_token.php?token=${token}`
        );
        const data = await res.json();
        if (!data.valid) {
          setError(data.message);
        } else {
          setVendorData(data);
        }
      } catch (err) {
        console.error(err);
        setError("Error verifying token.");
      }
    };

    checkToken();
  }, [token]);

  return (
    <div className="center_container">
      {error ? (
        <div className="form_container">
          <p className="title">Invalid or Expired Token</p>
          <p className="subtitle">{error}</p>
        </div>
      ) : success ? (
        <div className="form_container">
          <p className="title">Phone Number Updated!</p>
          <p className="subtitle">
            Your phone number has been successfully changed.
          </p>
        </div>
      ) : vendordata ? (
        <form
          className="form_container"
          onSubmit={handleSubmit}
          style={{
            filter: isSubmitting ? "blur(2px)" : "none",
            pointerEvents: isSubmitting ? "none" : "auto",
            opacity: isSubmitting ? 0.6 : 1,
            transition: "all 0.3s ease",
          }}
        >
          <div className="title_container">
            <p className="title">Update Your Phone Number</p>
            <span className="subtitle">
              Your registered email is <strong>{vendordata?.email}</strong>. If
              it's correct, proceed to update your Phone Number. Otherwise,
              please
              <a href="ambrosys.renobazaar.com/help">Contact Support</a>
            </span>
          </div>
          <br />
          <div className="input_container">
            <label className="input_label">Old Phone No.</label>
            <FaPhoneSquareAlt className="icon" />
            <input
              type="text"
              className="input_field"
              value={vendordata?.phone_no || ""}
              readOnly
            />
            {/* <input
              type="text"
              className="input_field"
              value={oldPhone}
              onChange={(e) => setOldPhone(e.target.value)}
              required
            /> */}
          </div>

          <div className="input_container">
            <label className="input_label">New Phone No.</label>
            <FaPhoneAlt className="icon" />
            <input
              type="text"
              className="input_field"
              value={newPhone}
              onChange={(e) => setNewPhone(e.target.value)}
              required
            />
          </div>

          <button type="submit" className="sign-in_btn">
            <span>Change Phone No</span>
          </button>
        </form>
      ) : (
        <div className="form_container">
          <p className="title">Verifying Token...</p>
        </div>
      )}
    </div>
  );
}

export default Changephone;
